<template>
  <q-dialog v-model="confirm" persistent>
    <q-card style="min-height: 420px; max-height: 420px; width: 700px">
      <q-card-section class="column">
        <span style="color: #21324a" class="mensagem-text"
          >Tem certeza que deseja incluir os produto(s)?</span
        >
        <q-separator style="height: 1px; background-color: #21324a" />
      </q-card-section>

      <q-card-section
        style="min-height: 300px; max-height: 300px; overflow-y: scroll"
      >
        <slot></slot>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          label="Confirmar"
          :disabled="false"
          no-caps
          icon="done"
          v-close-popup
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          @click="$emit('resultado', true)"
        />
        <q-btn
          icon="close"
          no-caps
          label="Cancelar"
          v-close-popup
          style="
            background-color: white;
            border-radius: 8px;
            color: #21324a;
            font-weight: normal;
            border: 1px solid #21324a;
          "
          @click="$emit('resultado', false)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { watch, ref } from "vue";
export default {
  props: ["mensagem", "exibir", "desabilitarConfirme"],
  setup(props) {
    const confirm = ref(false);

    watch(
      () => props.exibir,
      () => {
        confirm.value = props.exibir;
      }
    );
    return {
      confirm,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
